/** Beschikbaarheid-weekdagen (ma–zo). Eén bron voor create- en detail-forms. */
export const AVAILABILITY_WEEKDAYS: ReadonlyArray<{ key: string; label: string }> = [
  { key: 'monday', label: 'Maandag' },
  { key: 'tuesday', label: 'Dinsdag' },
  { key: 'wednesday', label: 'Woensdag' },
  { key: 'thursday', label: 'Donderdag' },
  { key: 'friday', label: 'Vrijdag' },
  { key: 'saturday', label: 'Zaterdag' },
  { key: 'sunday', label: 'Zondag' },
]

/** Dag-key → NL label, afgeleid van AVAILABILITY_WEEKDAYS. */
export const AVAILABILITY_DAY_LABELS: Record<string, string> = Object.fromEntries(
  AVAILABILITY_WEEKDAYS.map((d) => [d.key, d.label]),
)

/** Default beschikbaarheid: werkdagen aan, weekend uit (meeste monteurs ma–vr). */
export const DEFAULT_AVAILABILITY: Record<string, boolean> = {
  monday: true, tuesday: true, wednesday: true, thursday: true, friday: true,
  saturday: false, sunday: false,
}
